module.exports = __webpack_public_path__ + "img/hellow.9da3f92d.png";